import React, { useState } from 'react';
import { Image, message, Popover } from 'antd';
import urlImg from '../../../img/Stand_Small.png';
import style from './basicStands.module.scss';

const BasicStand = ({ setImages, images }) => {
  const {
    imgStand,
    logoContainer,
    upBannerContainer,
    centerContainer,
    fixedLeftContainer,
    fixedRightContainer,
  } = style;

  const [imageName, setImageName] = useState({});

  const upload = async (e) => {
    let names = [];

    let files = Array.from(e.target.files).map(file => {

      let reader = new FileReader();

      return new Promise(resolve => {

        reader.onload = () => resolve(reader.result);

        reader.readAsDataURL(file);
        names.push(file.name);
      });

    });

    // At this point you'll have an array of results
    return { files: await Promise.all(files), names: names };


  };

  const handleChange = async (e, max) => {
    if (images[e.target.name]?.length > max - 1) {
      message.error('No puedes cargar más imagenes en este lugar');
      return;
    }

    let res = await upload(e);
    setImages({
      [e.target.name]: res.files
    });

    setImageName({
      [e.target.name]: res.names
    });

    // Array.from(e.target.files).forEach(async (img) => {
    //   const reader = new FileReader();
    //   reader.readAsDataURL(img);
    //   reader.onloadend = async () => {
    //     console.log('lala');
    //     setImages({
    //       ...images,
    //       [e.target.name]: images[e.target.name] ? [...images[e.target.name], reader.result] : [reader.result]
    //     });
    //     await timeout(1000); //for 1 sec delay

    //   };

    //   setImageName({
    //     ...imageName,
    //     [e.target.name]: imageName[e.target.name] ? [...imageName[e.target.name], img.name] : [img.name],
    //   });

    //   await timeout(1000); //for 1 sec delay

    //   console.log('asd', images);
    // });
  };

  const content = bannerName => {
    return (
      <div>
        <p style={{ color: '#F57255' }}>** Al editar un banner se sobreescribirán las imágenes previamente cargadas. <br />Deberá subirlas nuevamente. **</p>
        {imageName[bannerName]?.map((img, i) => {
          return (
            <div key={i}>
              <span style={{ color: '#0F1F5D' }}>
                {i + 1}. {img}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const countFiles = (bannerName, max) => {
    const count = imageName[bannerName]?.length;
    if (count === undefined) return (<div>Espacios disponibles: {max}</div>);
    else return (<div>Espacios disponibles: {max - count}</div>);
  };

  return (
    <div>
      <Image preview={false}
        src={urlImg}
        alt="basic stand"
        className={imgStand}
      />
      <div className={logoContainer}>
        <span>Logo <br /> (262 x 262)</span>
        <Popover
          title={countFiles('logos', 1)}
          content={content('logos')}
        >
          <label htmlFor='inpLogo'>Examinar...</label>
        </Popover>
        <input
          id='inpLogo'
          type='file'
          name='logos'
          onChange={e => handleChange(e, 1)}
        />
      </div>
      <div className={upBannerContainer}>
        <span>Banner superior <br /> (686 x 262) </span>
        <Popover
          title={countFiles('upperBanner', 3)}
          content={content('upperBanner')}
        >
          <label htmlFor='inpUpBanner'>Examinar...</label>
        </Popover>
        <input
          id='inpUpBanner'
          type='file'
          name='upperBanner'
          multiple
          onChange={e => handleChange(e, 3)}
        />
      </div>
      <div className={centerContainer}>
        <span>Banner central <br /> (536 x 324)</span>
        <Popover
          title={countFiles('center', 3)}
          content={content('center')}
        >
          <label htmlFor='inpCenter'>Examinar...</label>
        </Popover>
        <input
          id='inpCenter'
          type='file'
          name='center'
          multiple
          onChange={e => handleChange(e, 3)}
        />
      </div>
      <div className={fixedLeftContainer}>
        <span>Banner inferior izquierdo <br /> (266 x 516)</span>
        <Popover
          title={countFiles('fixedLeft', 1)}
          content={content('fixedLeft')}
        >
          <label htmlFor='inpFixLeft'>Examinar...</label>
        </Popover>
        <input
          id='inpFixLeft'
          type='file'
          name='fixedLeft'
          onChange={e => handleChange(e, 1)}
        />
      </div>
      <div className={fixedRightContainer}>
        <span>Banner inferior derecho <br /> (266 x 516)</span>
        <Popover
          title={countFiles('fixedRight', 1)}
          content={content('fixedRight')}
        >
          <label htmlFor='fixRight'>Examinar...</label>
        </Popover>
        <input
          id='fixRight'
          type='file'
          name='fixedRight'
          onChange={e => handleChange(e, 1)}
        />
      </div>
    </div>
  );
};

export default BasicStand;

